import {util} from '@nuskin/ns-util';
import {AuthenticationService, UserService} from '@nuskin/ns-account';

export default {
    isGuestCheckout
}

function isGuestCheckout() {
    return (AuthenticationService.isLoggedIn() &&
        UserService.getUser().isGuest) ||
        (!AuthenticationService.isLoggedIn() && util.allowAnonymousShopping() && util.getSponsorId());
}
